import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './ModalErr.scss'

const ModalErr = ({title,  setIsModal}) => {

    return (
        <div className='blackout'>  
            <div className='modal-err'>
                <button className='btn-close'
                onClick={(e) => setIsModal(false)}
                ></button>
                <h2 className='title'>Что-то пошло не так</h2>
                <p className='text_grey-blue'></p>
                <button  onClick={(e) => setIsModal(false)}  className='btn-done'></button>
            </div>
       </div>
    )
}

export { ModalErr }